<template>
    <v-card
        block
        outlined
        elevation="0"
        :href="item.url"
        target="_blank"
        rel="external"
        class="sticker-card"
    >
        <div class="image">
            <v-img
                :src="item.thumbnail.url"
                v-if="item.thumbnail"
            ></v-img>
            <p v-else class="icon mb-0 text-center"><v-icon color="primary">fal fa-sticky-note</v-icon></p>
        </div>

        <p class="text-center ma-3">
            {{ item.title }}
            <strong class="d-block text--secondary" v-if="item.price">{{ item.price|format_price }}</strong>
            <small class="d-block text--secondary" v-if="item.size">{{ item.size }}</small>
        </p>
        <v-card-actions class="align-center grey lighten-3">
            <v-btn text small color="primary">Purchase</v-btn>
            <v-spacer></v-spacer>
            <v-btn icon color="primary"><v-icon>fal fa-angle-right</v-icon></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "StickerCard",
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
